import { memo } from 'react';

const ListItem = ({ renderItem, item }) => {
  return renderItem(item);
};

export default memo(ListItem);
